export default {
  de: {
    examples: 'Mustervorlagen',
  },
};
